// PGCET MCA Mock 6 — Analytical Ability & Logical Reasoning (questions 56–70)
const pgcetmcaAnalyticalReasoning = [
  {
    id: 56,
    question: "Six persons P, Q, R, S, T and U sit in a row facing north. S sits third from the left end. P sits to the immediate right of S. T sits second to the left of P. Q sits at the left end. U is not adjacent to P. Who sits between P and U?",
    options: ["A. S", "B. R", "C. T", "D. Q"],
    answer: "B"
  },
  {
    id: 57,
    question: "Six friends L, M, N, O, P and Q sit around a circular table facing the centre. L sits opposite O. M sits to the immediate left of L. N sits between O and Q. Who sits opposite M?",
    options: ["A. P", "B. Q", "C. N", "D. L"],
    answer: "C"
  },
  {
    id: 58,
    question: "Statements: Some doctors are singers. All singers are dancers. Conclusions: I. Some doctors are dancers. II. Some dancers are doctors. Which conclusion(s) follow?",
    options: ["A. Only I follows", "B. Only II follows", "C. Either I or II follows", "D. Both I and II follow"],
    answer: "D"
  },
  {
    id: 59,
    question: "Statements: All roses are flowers. No flower is a tree. Conclusions: I. No rose is a tree. II. Some trees are roses. Which conclusion(s) follow?",
    options: ["A. Only I follows", "B. Only II follows", "C. Both I and II follow", "D. Neither I nor II follows"],
    answer: "A"
  },
  {
    id: 60,
    question: "Statements: Some keys are locks. Some locks are doors. Conclusions: I. Some keys are doors. II. No key is a door. Which conclusion(s) follow?",
    options: ["A. Only I follows", "B. Only II follows", "C. Either I or II follows", "D. Neither I nor II follows"],
    answer: "C"
  },
  {
    id: 61,
    question: "Find the next number in the series: 1, 3, 7, 13, 21, 31, ?",
    options: ["A. 41", "B. 43", "C. 45", "D. 42"],
    answer: "B"
  },
  {
    id: 62,
    question: "Find the next number in the series: 6, 11, 21, 36, 56, ?",
    options: ["A. 81", "B. 76", "C. 86", "D. 91"],
    answer: "A"
  },
  {
    id: 63,
    question: "Find the wrong number in the series: 1, 8, 27, 64, 124, 216",
    options: ["A. 8", "B. 27", "C. 124", "D. 216"],
    answer: "C"
  },
  {
    id: 64,
    question: "Find the next letter in the series: Z, W, S, P, L, I, ?",
    options: ["A. F", "B. E", "C. D", "D. G"],
    answer: "B"
  },
  {
    id: 65,
    question: "Find the next number in the series: 4, 6, 12, 30, 90, ?",
    options: ["A. 270", "B. 360", "C. 405", "D. 315"],
    answer: "D"
  },
  {
    id: 66,
    question: "In a row of children facing north, Asha is 9th from the left and Bina is 6th from the right. When they interchange their positions, Asha becomes 15th from the left. How many children are there in the row?",
    options: ["A. 20", "B. 21", "C. 19", "D. 24"],
    answer: "A"
  },
  {
    id: 67,
    question: "P is Q's brother. R is Q's father. S is R's sister. How is P related to S?",
    options: ["A. Son", "B. Brother", "C. Nephew", "D. Cousin"],
    answer: "C"
  },
  {
    id: 68,
    question: "Kiran walks 8 km towards West and then 6 km towards South. What is the shortest distance between Kiran and his starting point?",
    options: ["A. 14 km", "B. 10 km", "C. 2 km", "D. 12 km"],
    answer: "B"
  },
  {
    id: 69,
    question: "In a certain code, ROSE is written as 6821 and CHAIR is written as 73456. How is SEARCH written in that code?",
    options: ["A. 214673", "B. 214763", "C. 241673", "D. 216473"],
    answer: "A"
  },
  {
    id: 70,
    question: "Four persons A, B, C and D sit around a square table, one on each side, facing the centre. A faces B. C sits to the immediate right of A. Who sits to the immediate left of A?",
    options: ["A. B", "B. C", "C. Cannot be determined", "D. D"],
    answer: "D"
  }
];

export default pgcetmcaAnalyticalReasoning;
